import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { ADD_ACTIVITY, getApiBaseUrl, LOGIN } from "../../../Config/Config";
import { Spin, Select } from "antd";
const { Option } = Select;

const NewAssetItemLite = () => {
  const [filterTypes, setFilterTypes] = useState([]);
  const [Locations, setLocationTypes] = useState([]);
  const [locationTypes, setLocationTypeOptions] = useState([]);
  const [ahuOptions, setAhuOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selected, setSelected] = useState(null);
  const [formData, setFormData] = useState({
    AHUId: "",
    AHUName: "",
    assetType: null,
    Location: "",
    Dimensions: "",
    MicronRating: "",
    LastCleaningDate: "",
    currentStatus: "",
    Lable: "",
    CreatedBy: null,
    cleaningFreqAllowance: "",
    cleaningdays: "",
    Loc: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleChange = (values) => {
    const inputValue = values[values.length - 1];
    const match = ahuOptions.find(
      (opt) => opt.code?.toLowerCase() === inputValue?.toLowerCase()
    );
    if (match) {
      setSelected({ id: match.id, code: match.code });
    } else {
      setSelected({ id: "", code: inputValue });
    }
  };

  useEffect(() => {
    fetchAHUIds();
  }, []);

  const fetchAHUIds = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getAHUIds`);
      const data = await res.json();
      if (data?.Status) {
        setAhuOptions(data.ResultData);
      } else {
        console.error("Error fetching AHU IDs:", data);
        setAhuOptions([]);
      }
    } catch (err) {
      console.error("Network error fetching AHU IDs:", err);
      setAhuOptions([]);
    }
  };

  useEffect(() => {
    fetchFilterTypes();
  }, []);

  const fetchFilterTypes = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getFilterType`);
      if (!res.ok) throw new Error("Failed to fetch filter types");
      const data = await res.json();
      if (data?.Status) {
        setFilterTypes(data.ResultData);
      } else {
        console.error("Error in API response:", data);
        setFilterTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setFilterTypes([]);
    }
  };

  useEffect(() => {
    fetchLocationTypes();
  }, []);

  const fetchLocationTypes = async () => {
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getprocessnonprocess?locType=0`
      );
      if (!res.ok) throw new Error("Failed to fetch AHU types");
      const data = await res.json();
      if (data?.Status) {
        setLocationTypes(data.ResultData);
      } else {
        console.error("API Error:", data);
        setLocationTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setLocationTypes([]);
    }
  };

  useEffect(() => {
    fetchLocationTypeOptions();
  }, []);

  const fetchLocationTypeOptions = async () => {
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getprocessnonprocess?locType=1`
      );
      if (!res.ok) throw new Error("Failed to fetch AHU type options");
      const data = await res.json();
      if (data?.Status) {
        setLocationTypeOptions(data.ResultData);
      } else {
        console.error("API Error:", data);
        setLocationTypeOptions([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setLocationTypeOptions([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = {
      assetType: formData.assetType,
      Location: formData.Location,
      Dimensions: formData.Dimensions,
      MicronRating: formData.MicronRating,
      Lable: formData.Lable,
      CleaningFrequencyDays: formData.CleaningFrequencyDays,
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([, value]) => !value || value.toString().trim() === "")
      .map(([key]) => key);

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Required Fields",
        // text: `Please fill in: ${missingFields.join(", ")}`,
        text: `Please fill in Required Fields`,
      });
      return;
    }

    let user;
    try {
      const userData = sessionStorage.getItem("user");
      if (!userData) {
        throw new Error("User data not found in session storage.");
      }
      user = JSON.parse(userData);
      if (!user.UserID) {
        throw new Error("User ID not found in user data.");
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      setIsSubmitting(false);
      return;
    }

    const toSQLDate = (dateStr) => {
      if (!dateStr) return null;
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return null;
      return d.toISOString().slice(0, 10);
    };

    const payload = {
      AHUId: selected?.id || "",
      AHUName: selected?.id ? "" : selected?.code || "",
      AssetType: formData.assetType,
      InstalledOn: new Date().toISOString().split("T")[0],
      Location: formData.Location,
      Dimensions: formData.Dimensions,
      MicronRating: formData.MicronRating,
      LastCleaningDate: toSQLDate(formData.LastCleaningDate) || "NULL",
      CurrentStatus: "Active",
      Lable: formData.Lable,
      Status: 0,
      CreatedBy: user.UserID, // Use the user variable
      cleaningFreqAllowance: formData.CleaningFrequencyDays,
      cleaningdays: formData.cleaningdays,
      Loc: formData.Loc,
    };

    try {
      setIsSubmitting(true);
      const response = await fetch(`${getApiBaseUrl()}/api/AddFilterLite`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      let noteMessage = "";

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error:", response.statusText, errorText);
        noteMessage = "Server error while saving filter";
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Failed to save filter. Please try again.",
        });
        await logActivity(false, noteMessage, user.UserID);
        return;
      }

      const data = await response.json();
      const result = data?.ResultData?.[0] || {};

      if (result?.Status === "Success") {
        noteMessage = "New Filter added successfully";
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: noteMessage,
          confirmButtonText: "OK",
        });
        await logActivity(true, noteMessage, user.UserID);
        window.location.reload();
      } else {
        noteMessage =
          result?.Message || result?.ResultMessage || "Filter saving failed";
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: noteMessage,
        });
        await logActivity(false, noteMessage, user.UserID);
      }
    } finally {
      setIsSubmitting(false);
    }

    async function logActivity(success, notes, userId) {
      const activityPayload = {
        ActivityType: 11,
        PerformedBy: userId,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: notes,
        Location: "AddAHUFilter",
        IsSucces: success ? 1 : 0,
      };

      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(activityPayload),
        });
      } catch (activityErr) {
        console.error("Audit logging failed:", activityErr);
      }
    }

    resetForm();
  };

  const resetForm = () => {
    setFormData({
      AHUId: "",
      AHUName: "",
      assetType: "",
      Manufacturer: "",
      InstalledOn: "",
      Location: "",
      Loc: "",
      Dimensions: "",
      MicronRating: "",
      LastCleaningDate: "",
      ValidOperationLife: "",
      currentStatus: "",
      availabilityStatus: "",
      Lable: "",
      CleaningFrequencyDays: "",
      cleaningdays: "",
    });
    setSelectedFile(null);
    setAskPassword(false);
    setPassword("");
    setError("");
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightNewFilterAsset");

    const handleOffcanvasClose = () => {
      resetForm();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/sampleFilterExcelLite`,
        {
          method: "GET",
        }
      );

      if (!response.ok) throw new Error("Failed to download file");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "sample-filter-template.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download the template. Please try again.");
    }
  };

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    let user;
    try {
      const userData = sessionStorage.getItem("user");
      if (!userData) {
        throw new Error("User data not found in session storage.");
      }
      user = JSON.parse(userData);
      if (!user.UserName) {
        throw new Error("User name not found in user data.");
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      setError("Invalid user data. Please log in again.");
      setAuthLoading(false);
      return;
    }

    try {
      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await performUpload(user.UserID); // Pass user.UserID to performUpload
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again."
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  const handleUploadClick = async () => {
    const userData = sessionStorage.getItem("user");
    if (!userData) {
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    if (!selectedFile) {
      Swal.fire({
        icon: "warning",
        title: "No file selected",
        text: "Please select an Excel file to upload.",
      });
      return;
    }

    setAskPassword(true);
  };

  const performUpload = async (userId) => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("UserID", userId);

    let uploadSuccess = 0;

    try {
      setIsSubmitting(true);
      const response = await fetch(
        `${getApiBaseUrl()}/api/uploadFilterExcelLite`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok && result.status) {
        uploadSuccess = 1;

        await Swal.fire({
          icon: "success",
          title: "Upload Successful",
          html: `
    <p><b>${result?.message}</b></p>
    <p>
      <b>Total:</b> ${result?.total} |
      <b>Success:</b> ${result?.successCount} |
      <b>Failed:</b> ${result?.failedCount}
    </p>
  `,
        });

        window.location.reload();
      } else {
        const failedList = result?.failed ?? [];

        const failedHtml =
          failedList.length > 0
            ? `
      <hr/>
      <p><b>Failed Rows:</b></p>
      <p>${failedList.map((f) => f.row).join(", ")}</p>
    `
            : "";

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          html: `
            <p><b>${result?.message || "Something went wrong."}</b></p>
            <p>
              <b>Total:</b> ${result?.total || 0} |
              <b>Success:</b> ${result?.successCount || 0} |
              <b>Failed:</b> ${result?.failedCount || 0}
            </p>
            ${failedHtml}
          `,
          width: 400,
        });
        window.location.reload();
      }
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Error",
        text: "Something went wrong while uploading.",
      });
    } finally {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: userId,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: `Bulk filter upload ${
              uploadSuccess ? "succeeded" : "failed"
            }`,
            Location: "Bulk filter upload",
            IsSucces: uploadSuccess,
          }),
        });
      } catch (logErr) {
        console.error("Audit log error:", logErr);
      }
      setIsSubmitting(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };

  return (
    <>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightNewFilterAsset {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightNewFilterAsset {
            width: 85% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightNewFilterAsset {
            width:85% !important;
          }
        }
        @media (min-width: 1441px)  {
          #offcanvasRightNewFilterAsset {
            width: 80% !important;
          }
        }
        `}
      </style>

      {(isSubmitting || authLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightNewFilterAsset"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header d-flex justify-content-between align-items-center">
            <h4 id="offcanvasRightLabel">Add New Filter</h4>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <hr className="m-0" />
          <div className="offcanvas-body">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <div className="row">
              <div className="col-4 mb-3">
                <label className="form-label">Block</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select Block"
                  value={formData.Location || undefined}
                  onChange={(value) =>
                    setFormData({ ...formData, Location: value })
                  }
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  disabled={askPassword}
                >
                  {Locations.map((item) => (
                    <Option key={item.BlockId} value={item.BlockId}>
                      {item.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">AHU ID</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  mode="tags"
                  placeholder="Select AHU Unique ID"
                  value={selected ? [selected.code] : []}
                  onChange={handleChange}
                  className="w-100"
                  disabled={askPassword}
                >
                  {ahuOptions.map((ahu) => (
                    <Option key={ahu.id} value={ahu.code}>
                      {ahu.code}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">AHU Type</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select AHU Type"
                  value={formData.Loc || undefined}
                  onChange={(value) => setFormData({ ...formData, Loc: value })}
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  disabled={askPassword}
                >
                  {locationTypes.map((item) => (
                    <Option key={item.BlockId} value={item.BlockId}>
                      {item.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Filter ID</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Filter ID"
                  value={formData.Lable}
                  onChange={(e) =>
                    setFormData({ ...formData, Lable: e.target.value })
                  }
                  disabled={askPassword}
                />
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Filter Size (In Micron)</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="number"
                  className="form-control"
                  required
                  onWheel={(e) => e.target.blur()}
                  placeholder="Enter Micron Rating"
                  value={formData.MicronRating}
                  onChange={(e) =>
                    setFormData({ ...formData, MicronRating: e.target.value })
                  }
                  disabled={askPassword}
                />
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Filter Type/Category</label>
                <span className="text-danger ms-1">*</span>
                <Select
                  showSearch
                  placeholder="Select Filter Type"
                  value={formData.assetType || undefined}
                  onChange={(value) =>
                    setFormData({ ...formData, assetType: value })
                  }
                  className="w-100"
                  required
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.props?.children
                      ?.toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  disabled={askPassword}
                >
                  {filterTypes.map((item) => (
                    <Option key={item.Id} value={item.Id}>
                      {item.AssetType}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Filter Dimensions</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  required
                  className="form-control"
                  placeholder="e.g. 500×300×200 mm"
                  value={formData.Dimensions}
                  onChange={(e) =>
                    setFormData({ ...formData, Dimensions: e.target.value })
                  }
                  disabled={askPassword}
                />
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Cleaning Frequency</label>
                <span className="text-danger ms-1">*</span>
                <div className="input-group">
                  <input
                    type="number"
                    min={0}
                    required
                    className="form-control"
                    onWheel={(e) => e.target.blur()}
                    placeholder="Enter Cleaning Freq. Days"
                    value={formData.cleaningdays}
                    onChange={(e) =>
                      setFormData({ ...formData, cleaningdays: e.target.value })
                    }
                    disabled={askPassword}
                  />
                  <span className="input-group-text">Days</span>
                </div>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Tolerance</label>
                <span className="text-danger ms-1">*</span>
                <div className="input-group">
                  <span className="input-group-text">±</span>
                  <input
                    type="number"
                    required
                    min={0}
                    className="form-control"
                    onWheel={(e) => e.target.blur()}
                    placeholder="Enter Cleaning Freq. Allowance"
                    value={formData.CleaningFrequencyDays}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        CleaningFrequencyDays: e.target.value,
                      })
                    }
                    disabled={askPassword}
                  />
                  <span className="input-group-text">Days</span>
                </div>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label">Last Cleaning Date</label>
                <span className="text-danger ms-1"></span>
                <input
                  type="date"
                  className="form-control"
                  value={formData.LastCleaningDate}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      LastCleaningDate: e.target.value,
                    })
                  }
                  disabled={askPassword}
                />
              </div>
            </div>

            <div className="col-12 d-flex justify-content-between">
              Bulk upload template:
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                title="Download Template"
                onClick={handleDownloadTemplate}
                disabled={askPassword}
              >
                <i className="fa fa-download fs-4"></i>
              </button>
            </div>
            <div className="col-12 d-flex justify-content-start mt-2">
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                disabled={askPassword}
              />
              {selectedFile && (
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleUploadClick}
                  disabled={askPassword}
                >
                  Upload Excel
                </button>
              )}
            </div>

            {askPassword && (
              <div className="col-4">
                <div className="mb-3  m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default NewAssetItemLite;
